import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { getExistsExpandedSteps } from '../selectors'

export function useExistsExpandedSteps() {
  return useSelector<RootState, boolean>(getExistsExpandedSteps)
}
